<template>
  <div v-if="$buttonAuthority(allButton, 'list')">
    <div v-if="!isReply">
      <div class="search-class">
        <el-form
          :model="searchTxt"
          :inline="true"
          size="small"
          class="serarch-form"
          label-position="right"
          label-width="110px"
        >
          <el-form-item label="平台账号">
            <el-select
              v-model="searchTxt.accountId"
              clearable
              filterable
              multiple
              collapse-tags
              reserve-keyword
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in amazonAccountList"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邮件主题">
            <el-input
              class="input-width"
              v-model="searchTxt.subject"
            ></el-input>
          </el-form-item>
          <el-form-item label="收件人邮箱">
            <el-input
              class="input-width"
              v-model="searchTxt.recipients"
            ></el-input>
          </el-form-item>
          <el-form-item label="收件时间">
            <el-date-picker
              v-model="searchTxt.sendBeginTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              class="input-width"
            >
            </el-date-picker>
            -
            <el-date-picker
              v-model="searchTxt.sendEndTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              class="input-width"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="标签">
            <el-select
              v-model="searchTxt.labelConfigId"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in labelConfigList"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回复状态">
            <el-select
              v-model="searchTxt.isReply"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in dropList.isReply"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邮件类型">
            <el-select
              v-model="searchTxt.emailType"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in dropList.EmailType"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回复时间">
            <el-date-picker
              v-model="searchTxt.replyBeginTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              class="input-width"
            >
            </el-date-picker>
            -
            <el-date-picker
              v-model="searchTxt.replyEndTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              class="input-width"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="发件人邮箱">
            <el-input class="input-width" v-model="searchTxt.sender"></el-input>
          </el-form-item>
          <el-form-item label="客服人员">
            <el-select
              v-model="searchTxt.userId"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in dropList.userList"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="其他邮件">
            <el-checkbox v-model="isCheck"></el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button
              style="margin-left: 50px"
              type="primary"
              @click="search()"
              icon="el-icon-search"
              >查找</el-button
            >
            <el-button @click="reset()" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="main-table">
        <div class="table-header">
          <el-button
            @click="batchIsReply"
            class="button-class"
            type="primary"
            v-if="$buttonAuthority(allButton, 'batchIsReply')"
            >批量标记已回复</el-button
          >
          <el-button
            @click="batchIsRead(1)"
            class="button-class"
            type="warning"
            v-if="$buttonAuthority(allButton, 'batchIsRead')"
            >标记为已读</el-button
          >
          <el-button
            @click="batchIsRead(2)"
            class="button-class"
            type="warning"
            v-if="$buttonAuthority(allButton, 'batchNoRead')"
            >标记为未读</el-button
          >
          <el-button
            class="button-class"
            @click="changeCustomer"
            icon="el-icon-chat-dot-round"
            v-if="$buttonAuthority(allButton, 'changeCustomer')"
            >更换客服人员</el-button
          >
        </div>
        <commonTable
          ref="multipleTable"
          type="selection"
          :loading="loading"
          :tableData="tableData"
          :tableLabel="tableLabel"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          :pageSize="pagination.pageSize"
          :currentPage="pagination.page"
          :total="pagination.total"
          :tableOption="tableOption"
          @handleButton="handleButton"
          @handleSelectionChange="handleSelectionChange"
        ></commonTable>
      </div>
      <div v-if="isLog">
        <logLook
          :modelName="modelName"
          :logType="logType"
          :id="scope.id"
          @lookClick="isShowEdit"
        ></logLook>
      </div>
    </div>
    <div v-if="isReply">
      <replay
        :scope="scope"
        @isShowEdit="isShowEdit"
        @getList="getList"
      ></replay>
    </div>
    <div v-if="isUpdata">
      <updata
        :scope="scope"
        @isShowEdit="isShowEdit"
        @getList="getList"
      ></updata>
    </div>
    <updateLabel
      v-if="isLabel"
      :scope="scope"
      @isShowEdit="isShowEdit"
      @getList="getList"
      :labelConfigList="labelConfigList"
    ></updateLabel>
    <sign
      v-if="isSign"
      :scope="scope"
      @isShowEdit="isShowEdit"
      @getList="getList"
    ></sign>
  </div>
</template>
<script>
/**
 * 亚马逊待办邮件列表页
 * 功能：固定查询待办邮件（isTodo=1），支持批量标记已回复/已读/未读、更换客服、单条移出待办（isTodo=2）、查看日志
 */
import {
  amazonEmailList,
  getEmailCount,
  singRed,
  updateStatus,
} from "@/api/user";
import { sortAtoZ } from "@/utils/index.js";
import replay from "../components/replay";
import updata from "../components/updata";
import updateLabel from "../components/updateLabel";
import sign from "../components/sign";
import { getAmazonMailTitle } from "@/utils/tableLabel";
export default {
  components: { replay, updata, updateLabel, sign },
  data() {
    return {
      modelName: "mail",
      logType: "addMemberMessage",
      // 列表加载状态
      loading: true,
      isshowhidden: false,
      // 是否首次加载（首次加载后生成列定义）
      isFirst: true,
      // 是否打开日志弹窗
      isLog: false,
      // 是否进入邮件详情页
      isReply: false,
      // 是否打开更换客服弹窗
      isUpdata: false,
      // 是否打开标签弹窗
      isLabel: false,
      // 是否打开标记弹窗
      isSign: false,
      // 当前选中行数据
      scope: {},
      hiddenHeader: [],
      // 已回复总数
      isReplyCount: 0,
      // 未回复总数
      noReplyCount: 0,
      // 按钮权限列表
      allButton: [],
      // 待办邮件列表数据
      tableData: [],
      // 表格列定义
      tableLabel: [],
      titleMap: [],
      dropList: {},
      renderList: {},
      // 批量勾选的邮件数据
      dataList: [],
      scopeList: [],
      searchTxt: {
        userId: "",
        accountId: "",
        subject: "",
        recipients: "",
        sender: "",
        sendBeginTime: "",
        sendEndTime: "",
        mailType: "",
        labelConfigId: "",
        isReply: "",
        isRead: "",
        isTodo: 1,
        emailType: "9",
        sender: "",
        replyBeginTime: "",
        replyEndTime: "",
        otherEmail: "",
      },
      // 是否勾选"其他邮件"搜索条件
      isCheck: false,
      // 分页参数
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      // 表格操作列定义（移出、日志）
      tableOption: {
        label: "操作",
        width: "150",
        fixed: "right",
        options: [
          {
            label: "移出",
            type: "text",
            methods: "remove",
            size: "mini",
          },
          {
            label: "日志",
            type: "text",
            methods: "log",
            size: "mini",
          },
        ],
      },
    };
  },
  computed: {
    labelConfigList: {
      get() {
        return this.$store.getters.dropList.labelConfigList;
      },
    },
    amazonAccountList: {
      get() {
        return this.$store.getters.dropList.amazonAccountList;
      },
    },
  },
  created() {},
  activated() {
    // 页面激活时拉取下拉数据、按钮权限、加载列表并过滤操作列权限
    this.$store.dispatch("getDropListTwo", [
      "labelConfigList",
      "amazonAccountList",
    ]);
    this.allButton = this.$getStorage(this.$route.name + "_button");
    if (this.$buttonAuthority(this.allButton, "list")) {
      Object.assign(this.pagination, this.searchTxt);
      this.getList();
      this.tableOptionAuth();
      // this.getCount();
    }
  },
  methods: {
    /** 基于公共列配置生成表格列定义 */
    getTableLabel() {
      this.tableLabel = getAmazonMailTitle(this.dropList, this);
      this.loading = false;
    },
    // 标记为重要邮件
    singClick(row) {
      const status = row.isImportant === 1 ? 2 : 1;
      let param = {
        id: row.id,
        isImportant: status,
      };
      updateStatus(param).then((result) => {
        if (result.code == 200) {
          this.$message.success(result.msg);
          this.getList();
          this.$refs.multipleTable.clear();
        }
      });
    },
    // 邮件详情
    toReply(row) {
      this.scope = row;
      this.isReply = true;
    },
    /** 批量回复选中邮件（进入回复页） */
    batchReply() {
      if (this.dataList.length > 0) {
        this.isReply = true;
      } else {
        this.$message.warning("请选择操作对象");
      }
    },
    /** 查询待办邮件列表并刷新已读/未读统计 */
    getList() {
      this.loading = true;
      amazonEmailList(this.pagination).then((result) => {
        if (result.code == 200) {
          this.tableData = result.data.pageInfo.records;
          this.pagination.total = result.data.pageInfo.total;
          let label = result.data.renderList;
          this.dropList = result.data.dropList;
          if (label == null) {
            this.renderList = {};
          } else {
            Object.assign(this.renderList, label);
          }
          if (this.isFirst) {
            this.getTableLabel();
          } else {
            this.loading = false;
          }
          this.$refs.multipleTable.clear();
        }
      });
      this.getCount();
    },
    getCount() {
      // 已回复总条数
      getEmailCount().then((res) => {
        if (res.code === 200) {
          this.isReplyCount = res.data.isReply;
          this.noReplyCount = res.data.noReply;
        }
      });
    },
    // 标记已回复
    batchIsReply() {
      if (this.dataList.length > 0) {
        let ids = this.dataList.map((item) => {
          return item.id;
        });
        let param = {
          id: ids.join(","),
          isReply: 1,
        };
        updateStatus(param)
          .then((result) => {
            if (result.code == 200) {
              this.$message.success(result.msg);
              this.getList();
              this.$refs.multipleTable.clear();
            }
          })
          .catch((err) => {});
      } else {
        this.$message.warning("请选择操作对象");
      }
    },
    batchIsRead(val) {
      if (this.dataList.length > 0) {
        let ids = this.dataList.map((item) => {
          return item.id;
        });
        // 状态 1已读 2未读
        let param = {
          id: ids.join(","),
          status: val,
        };
        singRed(param)
          .then((result) => {
            if (result.code == 200) {
              this.$message.success(result.msg);
              this.getList();
              this.$refs.multipleTable.clear();
            }
          })
          .catch((err) => {});
      } else {
        this.$message.warning("请选择操作对象");
      }
    },
    /** 打开发送更换客服弹窗（ids 为选中邮件 id 集合） */
    changeCustomer() {
      if (this.dataList.length > 0) {
        let ids = this.dataList.map((item) => {
          return item.id;
        });
        this.scope.ids = ids;
        this.isUpdata = true;
      } else {
        this.$message.warning("请选择操作对象");
      }
    },
    /** 表格操作列按钮分发（日志/移出待办） */
    handleButton(data) {
      var funType = data.methods;
      if (funType === "log") {
        this.logInfo(data.row);
      } else if (funType === "remove") {
        this.removeClick(data.row);
      }
    },
    /** 打开日志弹窗 */
    logInfo(data) {
      this.scope = data;
      this.isLog = true;
    },
    // 单个移出待办
    removeClick(value) {
      let param = {
        id: value.id,
        isTodo: 2,
      };
      this.editStatus(param);
    },
    editStatus(param) {
      // 调更改邮件状态接口
      updateStatus(param).then((result) => {
        if (result.code == 200) {
          this.$message.success(result.msg);
          this.getList();
          this.$refs.multipleTable.clear();
        }
      });
    },
    /** 关闭所有弹窗/详情页，回到列表并清空勾选 */
    isShowEdit() {
      this.isLog = false;
      this.isReply = false;
      this.isUpdata = false;
      this.isLabel = false;
      this.isSign = false;
      this.dataList = [];
      this.scope = {};
      this.$refs.multipleTable && this.$refs.multipleTable.clear();
    },
    /** 分页大小变化时重新查询 */
    handleSizeChange(value) {
      this.pagination.pageSize = value;
      this.pagination.page = 1;
      this.getList();
    },
    /** 页码变化时重新查询 */
    handleCurrentChange(value) {
      this.pagination.page = value;
      this.getList();
    },
    /** 勾选变化时记录选中的邮件数据 */
    handleSelectionChange(value) {
      this.dataList = value;
    },
    /** 按搜索条件查询待办邮件列表 */
    search() {
      this.pagination.page = 1;
      this.searchTxt.otherEmail = this.isCheck ? 1 : 0;
      Object.assign(this.pagination, this.searchTxt);
      this.pagination.accountId = this.pagination.accountId.toString();
      this.isFirst = false;
      this.getList();
    },
    /** 清空搜索条件并重新查询 */
    reset() {
      this.pagination.page = 1;
      this.$delectObj(this.searchTxt);
      this.$delectObj(this.pagination, [
        "userId",
        "accountId",
        "subject",
        "recipients",
        "sender",
        "sendBeginTime",
        "sendEndTime",
        "mailType",
        "labelConfigId",
        "isReply",
        "isRead",
        "emailType ",
        "sender",
        "replyBeginTime",
        "replyEndTime",
        "otherEmail",
      ]);
      this.isFirst = false;
      this.isCheck = false;
      this.getList();
    },
    /** 按按钮权限过滤表格操作列 */
    tableOptionAuth() {
      let array = this.tableOption.options;
      let authOption = [];
      array.forEach((element) => {
        if (this.$buttonAuthority(this.allButton, element.methods)) {
          authOption.push(element);
        }
      });
      if (authOption.length > 0) {
        this.tableOption.options = authOption;
      } else {
        this.tableOption = {};
      }
    },
  },
};
</script>

<style scoped></style>
